// Self-hosted Lucide icons (no CDN — satisfies CSP and removes an external dep).
// Only the icons actually used across the three pages are imported, so the bundle
// stays small. Matches the mockups' `<i data-lucide="kebab-name">` + createIcons().
import {
  createIcons,
  ArrowRight,
  ArrowUp,
  ShieldCheck,
  ShieldAlert,
  Shield,
  Lock,
  MessageCircle,
  Headset,
  Terminal,
  Zap,
  Layers,
  Sparkles,
  Users,
  FileClock,
  Webhook,
  Check,
  Plus,
  Copy,
  Mail,
  Database,
  ScrollText,
  TimerReset,
  Globe,
  UserPlus,
  LogIn,
  SlidersHorizontal,
  BookOpen,
  Search,
  Info,
  LifeBuoy,
  Braces,
  Apple,
  Monitor,
  LogOut,
  Save,
  Palette,
  ArrowLeft,
  LayoutDashboard,
  KeyRound,
  Code,
  Building2,
  Activity,
  ListChecks,
  MailPlus,
  Hourglass,
  Link,
  X,
  Send,
  Trash2,
  UserMinus,
  Eye,
  List,
  RefreshCw,
  Archive,
  CheckCircle2,
  Circle,
  CreditCard,
  Calendar,
  TrendingUp,
  BadgeCheck,
  ArrowUpCircle,
  ExternalLink,
  Boxes,
  Split,
  Box,
  UserRoundCog,
  UserCog,
  EyeOff,
  MailCheck,
  Plug,
  PlugZap,
  ArrowLeftRight,
  Download,
  SearchCheck,
  RotateCcw,
  ClipboardPaste,
  FileText,
  AlertCircle,
  CalendarClock,
  BellRing,
} from "lucide";

const icons = {
  ArrowRight,
  ArrowUp,
  ShieldCheck,
  ShieldAlert,
  Shield,
  Lock,
  MessageCircle,
  Headset,
  Terminal,
  Zap,
  Layers,
  Sparkles,
  Users,
  FileClock,
  Webhook,
  Check,
  Plus,
  Copy,
  Mail,
  Database,
  ScrollText,
  TimerReset,
  Globe,
  UserPlus,
  LogIn,
  SlidersHorizontal,
  BookOpen,
  Search,
  Info,
  LifeBuoy,
  Braces,
  Apple,
  Monitor,
  LogOut,
  Save,
  Palette,
  ArrowLeft,
  LayoutDashboard,
  KeyRound,
  Code,
  Building2,
  Activity,
  ListChecks,
  MailPlus,
  Hourglass,
  Link,
  X,
  Send,
  Trash2,
  UserMinus,
  Eye,
  List,
  RefreshCw,
  Archive,
  CheckCircle2,
  Circle,
  CreditCard,
  Calendar,
  TrendingUp,
  BadgeCheck,
  ArrowUpCircle,
  ExternalLink,
  Boxes,
  Split,
  Box,
  UserRoundCog,
  UserCog,
  EyeOff,
  MailCheck,
  Plug,
  PlugZap,
  ArrowLeftRight,
  Download,
  SearchCheck,
  RotateCcw,
  ClipboardPaste,
  FileText,
  AlertCircle,
  CalendarClock,
  BellRing,
};

export function mountIcons() {
  createIcons({ icons });
}
